import React, { useContext } from "react";
import "../../styles/pages/Editor.scss";
import homebtn from "../../images/Homebtn.svg";
import Tooltip from "@mui/material/Tooltip";
import ValueContext from "../../ContextAPi/appContext";
import { useHistory } from "react-router-dom";
const BannerPreviewHeader = ({ additionalProps, bannerName, bannerType }) => {
  const history = useHistory();
  const appData = useContext(ValueContext);

  return (
    <>
      <div className="container-fluid editorTempheader">
        <div className="row editHeader">
          <div className="col-md-3 d-flex tempHeaderLeft">
            <div className="contstud-title">
              <div className=" d-flex editorHeading">
                <div className=" d-flex editorTempHeading">
                  <img
                    src={homebtn}
                    alt=""
                    className="backIcon"
                    onClick={(e) => {
                      history.push("/");
                    }}
                  />
                  <div className="vertical-line"></div>
                  <p className="templateheading">
                    {additionalProps?.showAssettype}
                    {`Editor | ${bannerType}`}
                  </p>

                  <br />
                  {additionalProps?.showAssettype === "Template" ? (
                    <div
                      className={
                        additionalProps?.showBannertype === "Animated"
                          ? "tempName"
                          : "tempNamebanner"
                      }
                    >
                      <Tooltip title={additionalProps?.showBannerName}>
                        <h6 className="editorTemp-name">
                          {additionalProps?.showBannerName}
                        </h6>
                      </Tooltip>
                    </div>
                  ) : (
                    <div
                      style={bannerType === "Animated" ? { right: "94px" } : { right: "72px" }}
                      className={
                        additionalProps?.showBannertype === "Animated"
                          ? "bnrNameAnimated"
                          : "bannernamersd"
                      }
                    >
                      <Tooltip title={bannerName}>
                        <h6 className="editorTemp-name">{bannerName}</h6>
                      </Tooltip>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3 editorPreviewTempheaderRight">
            <div className="col-md-2 editorHeaderTempRight">
              <div className="right-side">
                <div className="promomats-text-container promorsd">
                  <div className="source-text">Source</div>
                  <strong>PromoMats</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerPreviewHeader;
